import styled from "styled-components"
import DonateButton from "../components/DonateButton"

const StyledCallToAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3.25rem;
  padding: var(--side-padding);
`

const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 3.25rem;
  font-weight: bold;
`

const CallToAction = () => {
  return (
    <StyledCallToAction>
      <Text>
        Now more than ever, we need to come together 
        as human beings and help those most in need.
      </Text>
      <DonateButton/>
    </StyledCallToAction>
  )
}

export default CallToAction